import { globalOnDemandVars } from '../helper/context'
import { isDueDate } from './functions'
import { getScoreByRating } from './constants'
import { getMemorizingStatus } from './notebook'
import { getNewRecord, getRatingAsNumber } from './SM2+'
import { produce } from 'immer'
import { defer } from 'lodash'

export function nodeToUploadType2RootNode (node) {
  return {
    ...node,
    children: [],
    isUploadType2RootNode: true,
    isMultiple: globalOnDemandVars.uploadType2s()[node.uploadType2Id].switchForMultipleCard
  }
}

export function fragmentToNode (fragment, uploadType2Id, nodeId) {
  return {
    fragmentProperties: {
      kind: fragment.kind,
      textAnswer: fragment.textAnswer,
      cropConfig: fragment.cropConfig
    },
    id: fragment.id,
    uploadType2Id: uploadType2Id,
    editableValues: {
      ...fragment.learningRecord
    },
    isUploadType2Node: true
  }
}

export function getReadyForUploadType2 (uploadType2RootNode, dueDateSet, reStudySet, reTestSet, totalScoreObject, path) {
  const uploadType2Id = uploadType2RootNode.uploadType2Id
  const uploadType2 = globalOnDemandVars.uploadType2s()[uploadType2Id]
  const fragments = uploadType2.fragmentList
  let nodes = fragments.map((fragment) => (fragmentToNode(fragment, uploadType2Id, uploadType2RootNode.id)))

  const dailyLimitOn = globalOnDemandVars.dailyLimitOn()
  const dailyLimit = globalOnDemandVars.dailyLimit()
  const thoroughIds = globalOnDemandVars.thoroughIds().concat(globalOnDemandVars.addedThoroughIds())

  // const isThoroughNode = thoroughIds.some((oneId) => ((oneId === 'rootNode') || oneId === uploadType2RootNode.id || (path.some((pathId) => (oneId === pathId)))))
  const isThoroughNode = thoroughIds.some((oneId) => {
    const isThisNodeThorough = ((oneId === 'rootNode') || oneId === uploadType2RootNode.id || (path.some((pathId) => (oneId === pathId))))

    defer(() => {
      if (isThisNodeThorough) {
        if (oneId === 'rootNode') {
          globalOnDemandVars.set_courseStatus(produce(globalOnDemandVars.courseStatus(), draft => {
            draft.thoroughNodes = [globalOnDemandVars.topRootName()]
          }))
        } else if (oneId === uploadType2RootNode.id) {
          globalOnDemandVars.set_courseStatus(produce(globalOnDemandVars.courseStatus(), draft => {
            if (Array.isArray(draft.thoroughNodes)) {
              draft.thoroughNodes.push(uploadType2RootNode.title)
            } else {
              draft.thoroughNodes = [ uploadType2RootNode.title ]
            }
          }))
        }
      }
    })

    return isThisNodeThorough
  })

  for (const node of nodes) {
    if (dailyLimitOn && (dailyLimit <= totalScoreObject.nodeCountAtFirst)) {
      break
    }
    if (node.editableValues.failStatus && node.editableValues.failStatus !== 'solved') {
      switch (node.editableValues.failStatus) {
        case 'reStudy':
          reStudySet.add(node.id)
          node.editableValues.memorizingStatus = 'reStudy'
          totalScoreObject.score += getScoreByRating('reStudy')
          totalScoreObject.score += getScoreByRating('reTest')
          totalScoreObject.nodeCountAtFirst += 1
          break
        case 'reTest':
          reTestSet.add(node.id)
          node.editableValues.memorizingStatus = 'reTest'
          totalScoreObject.score += getScoreByRating('reTest')
          totalScoreObject.nodeCountAtFirst += 1
          break
      }
    } else if (isDueDate(node) || isThoroughNode) {
      dueDateSet.add(node.id)
      const memorizingStatus = getMemorizingStatus(node)
      node.editableValues.memorizingStatus = memorizingStatus
      if (memorizingStatus === 'okay') {
        if (process.env.NODE_ENV !== 'production') {
          console.tron.display({
            name: 'memorizingStatus okay',
            value: {
              node
            }
            // , important: true
          })
        }
      }
      totalScoreObject.score += getScoreByRating(memorizingStatus)
      totalScoreObject.nodeCountAtFirst += 1
      if (memorizingStatus === 'firstTime') {
        node.editableValues.firstTime = true
        totalScoreObject.firstTimeNodeCount += 1
      }
    }
  }
  Object.defineProperty(uploadType2RootNode, 'children', {
    value: nodes,
    configurable: false,
    writable: false,
    enumerable: true
  })
  Object.defineProperty(uploadType2RootNode, 'getReady', {
    get () {
      return this === uploadType2RootNode
    }
  })
}

export function updateFragmentValues (node, newFragmentProperties) {

}

export function pretifierForUploadType2 (root, expectedRating) {
  const doseFilterNeed = !(root.cutAlready)
  return {
    rootNode: root,
    chunk: !doseFilterNeed ? root.children : root.children.filter((node) => node.editableValues && node.editableValues.memorizingStatus === expectedRating)
  }
}

// -----------------------------------------------------------------------------------------------------------

function getNewRecordOfNode (node, rating) {
  return getNewRecord({
    difficulty: node.editableValues.difficulty,
    interval: node.editableValues.interval,
    update: node.editableValues.update
  }, getRatingAsNumber(rating))
}

export function updateFragmentBySM2 (node, rating, updateIdentifier) {
  const fragment = globalOnDemandVars.uploadType2s()[node.uploadType2Id].fragmentList
    .find((fragment) => (fragment.id === node.id))

  let newRecord
  if (!node.editableValues.updateIdentifier || node.editableValues.updateIdentifier !== updateIdentifier) {
    node.editableValues.updateIdentifier = updateIdentifier

    node.editableValues.prevRating = rating

    node.editableValues.prevRecord = {
      difficulty: fragment.learningRecord.difficulty,
      interval: fragment.learningRecord.interval,
      update: fragment.learningRecord.update
    }

    newRecord = getNewRecordOfNode({
      editableValues: {
        difficulty: fragment.learningRecord.difficulty,
        interval: fragment.learningRecord.interval,
        update: fragment.learningRecord.update
      }
    }, rating)
    if (updateIdentifier.endsWith('reTest') && rating === 'hard') {
      newRecord.difficulty = fragment.learningRecord.difficulty
    }

    node.editableValues.difficulty = newRecord.difficulty
    node.editableValues.interval = newRecord.interval
    node.editableValues.update = newRecord.update

    fragment.update({
      learningRecord: {
        difficulty: newRecord.difficulty,
        interval: newRecord.interval,
        update: newRecord.update,
        ratingRecord: fragment.learningRecord.ratingRecord.concat({
          rating: rating,
          time: Date.now()
        })
      }
    })
  } else {
    newRecord = getNewRecord(node.editableValues.prevRecord, getRatingAsNumber(rating))
    if (updateIdentifier.endsWith('reTest') && rating === 'hard') {
      newRecord.difficulty = fragment.learningRecord.difficulty
    }

    node.editableValues.difficulty = newRecord.difficulty
    node.editableValues.interval = newRecord.interval
    node.editableValues.update = newRecord.update

    fragment.update({
      learningRecord: {
        difficulty: newRecord.difficulty,
        interval: newRecord.interval,
        update: newRecord.update,
        ratingRecord: fragment.learningRecord.ratingRecord.concat({
          rating: rating,
          time: Date.now()
        })
      }
    })
  }
}

export function downdateFragmentBySM2 (node) {
  const prevRecord = node.editableValues.prevRecord

  const fragment = globalOnDemandVars.uploadType2s()[node.uploadType2Id].fragmentList
    .find((fragment) => (fragment.id === node.id))

  fragment.update({
    learningRecord: {
      ...prevRecord,
      ratingRecord: fragment.learningRecord.ratingRecord.slice(0, -1)
    }
  })
}

export function updateFragmentForFail (node, failStatus) {
  const fragment = globalOnDemandVars.uploadType2s()[node.uploadType2Id].fragmentList
    .find((fragment) => (fragment.id === node.id))

  fragment.update({
    learningRecord: {
      ...fragment.learningRecord,
      failStatus: failStatus
    }
  })
}
